<template>
    <div class="container">
        <v-row
         class="pb-3">
            <v-col
                cols="12">
                TEMPORAL
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="10">
                <v-row>
                    <v-col
                        cols="12"
                        md="6"
                        class="pb-0 pt-0">
                        <v-text-field
                            v-model="entradaEs"
                            label="Entrada español"
                            outlined
                            clearable
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        class="pb-0 pt-0">
                        <v-text-field
                            v-model="entradaEn"
                            label="Entrada inglés"
                            outlined
                            clearable
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="12"
                        class="pt-0">
                            <v-textarea
                            outlined
                            label="Salida"
                            rows="4"
                            v-model="salida"
                            ></v-textarea>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                cols="12"
                md="2"
                class="pb-0 pt-0">

                <v-row>
                    <v-col
                    cols="12">
                    <v-btn
                    :disabled="loading4"
                    color="primary"
                    @click="process()"
                    block
                    >
                    Procesar
                    <!--<template v-slot:loader>
                        <span class="custom-loader">
                        <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>-->
                    </v-btn>
                    <!--<v-btn
                    :loading="loading3"
                    :disabled="loading3"
                    color="primary"
                    @click="process()"
                    >
                    Procesar
                    </v-btn>-->
                    </v-col>
                    <v-col
                        cols="12">

                        <v-btn
                        color="error"
                        @click="delTable()"
                        block
                        >
                        delTable
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="6">
                    <v-simple-table
                    fixed-header
                    height="400px">
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-left">
                                String ES
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="(item, index) in listStringEs"
                            :key="index"
                            >
                            <td>{{ item.value }}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
            </v-col>
            <v-col
                cols="6">
                    <v-simple-table
                    fixed-header
                    height="400px">
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-left">
                                String EN
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="(item, index) in listStringEn"
                            :key="index"
                            >
                            <td>{{ item.value }}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import Constant from '../util/constant';
  import UtilMethod from '../util/utilMethod';
  import { v4 as uuidv4 } from 'uuid';

  export default {
    name: 'Otros',

    data:()=>({
        entradaEs: null,
        entradaEn: null,
        salida: null,
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,

        listStringEs:[],
        listStringEn:[]
    }),
    components: {
      //HelloWorld,
    },
    mounted(){
        if(localStorage.getItem('listEs')){
            this.listStringEs = JSON.parse(localStorage.getItem('listEs'));
        }

        if(localStorage.getItem('listEn')){
            this.listStringEn = JSON.parse(localStorage.getItem('listEn'));
        }
    },
    methods:{
        async process(){
            this.loading4 = true;
            //this.loader = 'loading4';
            let nameEntrada = this.entradaEs.toLowerCase()
            .replaceAll(" ","_")
            .replaceAll("ñ","n")
            .replaceAll("á","a")
            .replaceAll("é","e")
            .replaceAll("í","i")
            .replaceAll("ó","o")
            .replaceAll("ú","u")
            .replaceAll("¿","")
            .replaceAll("?","")
            .replaceAll("¡","")
            .replaceAll("!","")
            .replaceAll(",","")
            .replaceAll("-","")
            //.replaceAll("'","")
            .replaceAll(".","")
            .replaceAll(" de ","")
            .replaceAll(" la ","")
            .replaceAll("la ","")
            .replaceAll(" tu ","")
            .replaceAll("tu ","");
            this.entradaEn = await this.getEnglishEnter(this.entradaEs);
            let textSalidaEs =`<string name="${nameEntrada}">${this.entradaEs}</string>`;
            let textSalidaEn =`<string name="${nameEntrada}">${this.entradaEn}</string>`;
            let textCopied = `@string/${nameEntrada}`;
            this.salida = `${textSalidaEs}\n${textSalidaEn}\n${textCopied}`;
            navigator.clipboard.writeText(textCopied);
            this.listStringEs.push({value:textSalidaEs});
            localStorage.setItem('listEs',  JSON.stringify(this.listStringEs));
            this.listStringEn.push({value:textSalidaEn});
            localStorage.setItem('listEn',  JSON.stringify(this.listStringEn));
            this.loading4 = false;
        },
        delTable(){
            if(localStorage.getItem('listEs')){
                localStorage.removeItem('listEs');
            }

            if(localStorage.getItem('listEn')){
                localStorage.removeItem('listEn');
            }
            this.listStringEs=[];
            this.listStringEn=[];
        },
        async getEnglishEnter(text){
            let headers= {
                'content-type': 'application/json',
                'Ocp-Apim-Subscription-Key': Constant.KEY_SUSCRIPTION_AZURE,
                'Ocp-Apim-Subscription-Region': Constant.REGION_AZURE,
                'Content-type': 'application/json',
                'X-ClientTraceId': uuidv4().toString()
            };

            let body = [{'text': text}];

            let callbackThen = (response) => {
                let objOut = {
                    code:null,
                    message:null,
                    data:null
                };

                if(response.status == 200){
                    objOut.code = 1;
                    let translations = response.data[0].translations;
                    translations.forEach(item => {
                        objOut.message=item.text;
                    });
                }else{
                    objOut.message = "Oops, algo pasó..., Code: "+response.status;
                }
                
                return objOut;
            }
            
            let retorno = await UtilMethod.execApi("POST2",Constant.URI_TRANSLATE_AZURE+"--/translate--"+"?api-version=3.0&from=es&to=en",body,headers,callbackThen);
            return retorno.message;
        }
    },
    /*watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 100)

        this.loader = null
      },
    },*/
  }
</script>
<!--<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>-->